// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';
//import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import stepStore from '../stores/step-store.js';

import stepActions from '../actions/step-actions.js';
import scopeActions from '../../stele/actions/scope-actions.js';
import userActions from '../../userstorage/actions/user-actions.js';

import optionActions from '../../stele/actions/option-actions.js';

import T from '../../../nls/translate.js';

import * as stepConfig from './../../../config-steps.js';

//const switchStep2Upload = stepActions.switchStep.bind(stepActions, 'upload');

export default React.createClass({
	propTypes: {
		children: React.PropTypes.node //FIXME set required
	},
	mixins: [
		Reflux.connect(stepStore, 'data') // entspricht parameter von trigger() bei output: des stores
	],
	mainStep: function () {
		stepActions.switchStep(stepConfig.STEP_CONFIG, '');
		optionActions.clear();
	},
	render: function() {
		const data = this.state.data;
		if(data)
			return (
				<div className={ 'slx-step-'+data.name
								 + (data.substep ? ' slx-substep-' + data.substep : '')
								 + (data.extra ? ' ' + data.extra : '')
								 + (data.locked ? ' slx-step__locked' : '')
							   }
					>
					<div className="slx-footer">
						<span className="slx-footer__left" onClick={stepActions.prev} >&nbsp;</span>
						<span className="slx-footer__right" onClick={stepActions.next} >&nbsp;</span>
						{/*<span className="slx-footer__cross" onClick={scopeActions.clear} >&nbsp;</span>
						<span className="slx-footer__rotate" onClick={steleActions.resetToLastScopes} >&nbsp;</span>*/}
						<span className="slx-footer__rotate" onClick={scopeActions.clear} >&nbsp;</span>
						<span className="slx-footer__title">{data.title}</span>
						<span className="floatRight">
							{/*<span className="slx-footer__upload" onClick={switchStep2Upload}>{T.current.STEPS.foto}</span>*/}
							<span className="slx-footer__next" onClick={stepActions.next} >{T.current.STEPS.NEXT}</span>
							<span className="slx-footer__finished" onClick={this.mainStep} >{T.current.APPLY}</span>
							<span className="slx-footer__exit" onClick={stepActions.next} >&nbsp;</span>
							<span className="slx-footer__user" onClick={userActions.toggle}>&nbsp;</span>
						</span>
					</div>
					{this.props.children}
				</div>
					);
		else
			return (<div />);
	}
});

